module.exports = __webpack_public_path__ + "img/zjt.b1fafa17.png";